import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserBackendServer extends BaseBackend {
  getUsers(builder): Observable<any> {
    return this.get('/user', { params: builder });
  }

  exportUsers(builder): Observable<any> {
    return this.post('/user/export', builder);
  }

  getUser(username): Observable<any> {
    return this.get(`/user/${username}`);
  }

  getUserByBpNo(bpNo: string | string[]): Observable<any> {
    const bpNoArray = Array.isArray(bpNo) ? bpNo : [bpNo];
    const params: { [key: string]: string | string[] } = {
      bpNo: bpNoArray,
    };
    return this.get(`/user/bp`, { params });
  }

  getUserActivitySummary(data): Observable<any> {
    return this.get(`/user/user-activity-data`, { params: data });
  }

  updateUserBpsById(updateUserData): Observable<any> {
    return this.patch(`/user/b2b/bps/bps-by-user-id`, updateUserData);
  }

  getContact(bpNo): Observable<any> {
    return this.get(`/user/contact/${bpNo}`);
  }

  saveUser(user): Observable<any> {
    const { username } = user;
    if (user._id) {
      return this.patch(`/user/${username}`, user);
    }
    return this.post('/user', user);
  }

  saveUserAgreement(user): Observable<any> {
    const { username } = user;
    return this.patch(`/user/${username}/save-user-agreement`, user);
  }

  saveUserAddressFavorite(user, newAddress): Observable<any> {
    const { username } = user;
    return this.patch(
      `/user/${username}/save-user-address-favorite`,
      newAddress
    );
  }

  deleteUserAddressFavorite(user, newAddress): Observable<any> {
    const { username } = user;
    return this.patch(
      `/user/${username}/delete-user-address-favorite`,
      newAddress
    );
  }

  getAssignedDealers(username): Observable<any> {
    return this.get(`/user/${username}/assigned-dealers`);
  }

  assignDealers(userInfo, assignList): Observable<any> {
    let username = userInfo.username;
    return this.patch(`/user/${username}/assign-dealers`, assignList);
  }

  unAssignDealers(userInfo, unAssignList): Observable<any> {
    let username = userInfo.username;
    return this.patch(`/user/${username}/unassign-dealers`, unAssignList);
  }

  getMyLocationAliases(username): Observable<any> {
    return this.get(`/user/${username}/my-location-aliases`);
  }

  assignLocationAliases(username, assignLocationAliases): Observable<any> {
    return this.patch(
      `/user/${username}/assign-location-aliases`,
      assignLocationAliases
    );
  }

  unAssignLocationAliases(username, unAssignLocationAliases): Observable<any> {
    return this.patch(
      `/user/${username}/unassign-location-aliases`,
      unAssignLocationAliases
    );
  }

  checkDuplicateEmail(username): Observable<any> {
    return this.get(`/user-email-check/${username}`);
  }

  createB2bCustomer(customer): Observable<any> {
    return this.post('/customer-register', customer);
  }

  unlockUserAccount(username): Observable<any> {
    return this.patch(`/user/${username}/unlockUserAccount`, username);
  }

  getNewCustomers(builder): Observable<any> {
    return this.get('/user/request', { params: builder });
  }

  saveB2bUser(user): Observable<any> {
    const { username } = user;
    if (user._id) {
      return this.patch(`/user/b2b/${username}`, user);
    }
    return this.post('/user/b2b', user);
  }

  getSimpleProfile(username): Observable<any> {
    return this.get(`/user-profile/${username}`);
  }

  saveB2bSimpleProfile(user): Observable<any> {
    const { username } = user;
    if (user._id) {
      return this.patch(`/user-profile/b2b/${username}`, user);
    }
    return this.post('/user-profile/b2b', user);
  }

  getB2bUsers(builder): Observable<any> {
    return this.get('/user/b2b', { params: builder });
  }

  updateB2bRequestStatus(username, userInfo): Observable<any> {
    return this.patch(`/user/b2b/${username}/onboarding`, userInfo);
  }

  updateInquiryTypes(userId, inquiryTypes): Observable<any> {
    return this.patch(`/user/b2b/inquiry/${userId}/inquiryTypes`, {
      inquiryTypes: inquiryTypes,
    });
  }

  changePassword(userId, passwordData): Observable<any> {
    return this.patch(`/user/change-password/${userId}`, { ...passwordData });
  }
}
